import { render, staticRenderFns } from "./tinymce-editor.vue?vue&type=template&id=71edb42a&scoped=true&"
import script from "./tinymce-editor.vue?vue&type=script&lang=js&"
export * from "./tinymce-editor.vue?vue&type=script&lang=js&"
import style0 from "./tinymce-editor.vue?vue&type=style&index=0&id=71edb42a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71edb42a",
  null
  
)

export default component.exports